module.exports = __webpack_public_path__ + "img/UTKODA-15.82e10f40.jpg";